import { Types } from './types';
import { IMenu } from '../../interfaces/menu';

const MenuAction: IMenu.DispatchFromProps = {
  openMenu: () => ({ type: Types.SIDE_MENU_OPEN }),
  closeMenu: () => ({ type: Types.SIDE_MENU_COLLAPSE }),
};

export { MenuAction as mapDispatchToProps };
